module.exports = __webpack_public_path__ + "img/illustration_mobile_en.0561b8bc.png";